/// <amd-module name="Wiki/HeaderMetaData/HeaderMetaDataSource" />

import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { encodeUri } from "VSS/Platform/Util/Linking";
import * as VC_Contracts from "Wiki/Clients/VC/Contracts/Git";
import { getGitClient } from "Wiki/Clients/VC/RestClient/Git";
import * as WorkItemTracking from "Wiki/Clients/Wit/Contracts/WorkItemTracking";
import { getWorkItemTrackingClient } from "Wiki/Clients/Wit/RestClient/WorkItemTracking";
import { RepoConstants } from "Wiki/ViewCommon/Constants";

export class HeaderMetaDataSource {
    constructor(private _pageContext: IVssPageContext) {}

    // we need push details from commit - to make sure commit and push map
    public getCommitsData(
        version: VC_Contracts.GitVersionDescriptor,
        gitItemPath: string,
        projectId: string,
        repositoryId: string
    ): Promise<VC_Contracts.GitCommitRef[] | undefined> {
        const searchCriteria = {
            includeUserImageUrl: false,
            itemVersion: version,
            itemPath: gitItemPath,
            includePushData: true
        } as VC_Contracts.GitQueryCommitsCriteria;

        return getGitClient(this._pageContext).getCommitsBatch(searchCriteria, repositoryId, projectId, undefined, 1);
    }

    public getLinkedWorkItems(projectId: string, pagePath: string, wikiId: string): Promise<number[]> {
        const wikiPagePath = pagePath.charAt(0) === RepoConstants.RootPath ? pagePath.substring(1) : pagePath;
        const wikiPageArtifactId = format("{0}/{1}/{2}", projectId, wikiId, wikiPagePath);
        const wikiPageArtifactUri = encodeUri({
            tool: "Wiki",
            type: "WikiPage",
            id: wikiPageArtifactId
        });

        return this._getWorkItemIdsForArtifactUri(wikiPageArtifactUri, projectId);
    }

    private _getWorkItemIdsForArtifactUri(artifactUri: string, projectId: string): Promise<number[]> {
        const artifactUrisQuery = {
            artifactUris: [artifactUri]
        };

        return getWorkItemTrackingClient(this._pageContext)
            .queryWorkItemsForArtifactUris(artifactUrisQuery, projectId)
            .then((result: WorkItemTracking.ArtifactUriQueryResult) => {
                const workItems = result.artifactUrisQueryResult[artifactUri] || [];
                return workItems.map(workItem => workItem.id);
            });
    }
}
